import { StatsPieChart } from "./StatsPieChart";
export default StatsPieChart;
